import { Inject } from '@angular/core';
import templateSource from './app.component.html';
              import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz');
import { Component, OnInit, ChangeDetectorRef, ViewChild, ElementRef, DoCheck, OnDestroy, HostListener } from '@angular/core';
import { Service } from "src/libs/portal/season/service";
import moment from 'moment';
import { Router, NavigationEnd } from '@angular/router';

@Component({
    selector: 'app-root',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/app.component.scss */
.portal-chat {
  --chat-bg: #ffffff;
  --chat-text: #17324d;
  --chat-line: #dbe3ef;
  --chat-hover: #edf3fb;
}

:host-context(.dark) .portal-chat {
  --chat-bg: #172333;
  --chat-text: #e2eaf3;
  --chat-line: #344459;
  --chat-hover: #26384d;
}

.portal-chat-trigger {
  position: fixed;
  right: max(28px, env(safe-area-inset-right));
  bottom: max(28px, env(safe-area-inset-bottom));
  z-index: 90;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 54px;
  height: 54px;
  border: 1px solid rgba(255, 255, 255, 0.24);
  border-radius: 50%;
  color: #fff;
  background: linear-gradient(145deg, #258498 0%, #35578c 100%);
  box-shadow: 0 5px 16px rgba(23, 50, 77, 0.168627451), inset 0 1px 0 rgba(255, 255, 255, 0.1490196078);
  cursor: pointer;
  transition: transform 220ms ease, box-shadow 220ms ease;
  font-size: 20px;
}
.portal-chat-trigger:hover {
  transform: translateY(-2px);
  box-shadow: 0 8px 22px rgba(23, 50, 77, 0.2509803922), inset 0 1px 0 rgba(255, 255, 255, 0.1882352941);
}
.portal-chat-trigger:active {
  transform: translateY(0) scale(0.95);
}
.portal-chat-trigger.is-open {
  background: linear-gradient(145deg, #326b80, #344c72);
}

.portal-chat-panel {
  position: fixed;
  right: max(28px, env(safe-area-inset-right));
  bottom: calc(max(28px, env(safe-area-inset-bottom)) + 66px);
  z-index: 89;
  display: flex;
  flex-direction: column;
  width: min(440px, 100vw - 56px);
  height: min(640px, 100vh - 122px);
  height: min(640px, 100dvh - 122px - env(safe-area-inset-bottom));
  overflow: visible;
  border: 1px solid var(--chat-line);
  border-radius: 18px;
  background: var(--chat-bg);
  box-shadow: 0 20px 58px rgba(15, 23, 42, 0.2392156863);
  transform-origin: calc(100% - 27px) calc(100% + 39px);
  animation: portal-chat-open 440ms cubic-bezier(0.16, 1, 0.3, 1) both;
}
.portal-chat-panel::after {
  content: "";
  position: absolute;
  right: 21px;
  bottom: -7px;
  width: 13px;
  height: 13px;
  background: var(--chat-bg);
  border-right: 1px solid var(--chat-line);
  border-bottom: 1px solid var(--chat-line);
  transform: rotate(45deg);
}

@keyframes portal-chat-open {
  0% {
    opacity: 0;
    transform: translateY(12px) scale(0.18, 0.1);
  }
  65% {
    opacity: 1;
    transform: translateY(-2px) scale(1.006, 1.008);
  }
  100% {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
}
.portal-chat-surface {
  display: flex;
  flex: 1;
  flex-direction: column;
  min-height: 0;
  width: 100%;
  overflow: hidden;
  border-radius: inherit;
  background: var(--chat-bg);
}

@keyframes portal-chat-content-in {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
.portal-chat-header, .portal-chat-frame {
  animation: portal-chat-content-in 220ms ease 100ms both;
}

.portal-chat-header {
  flex: 0 0 auto;
  min-height: 48px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  padding: 6px 10px 6px 16px;
  border-bottom: 1px solid var(--chat-line);
  color: var(--chat-text);
  font-size: 14px;
  font-weight: 700;
}

.portal-chat-actions {
  display: flex;
  gap: 4px;
}

.portal-chat-action {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 34px;
  height: 34px;
  flex-shrink: 0;
  border: 0;
  border-radius: 6px;
  background: transparent;
  color: var(--chat-text);
  text-decoration: none;
  cursor: pointer;
}
.portal-chat-action:hover {
  background: var(--chat-hover);
}

.portal-chat-frame {
  display: block;
  flex: 1 1 auto;
  min-height: 0;
  width: 100%;
  height: 100%;
  border: 0;
  background: var(--chat-bg);
}

.portal-chat-trigger:focus-visible, .portal-chat-action:focus-visible {
  outline: 2px solid #60a5fa;
  outline-offset: 3px;
}

@media (max-width: 640px) {
  .portal-chat-trigger {
    right: max(16px, env(safe-area-inset-right));
    bottom: max(16px, env(safe-area-inset-bottom));
    width: 50px;
    height: 50px;
  }
  .portal-chat-panel {
    right: max(12px, env(safe-area-inset-right));
    bottom: calc(max(16px, env(safe-area-inset-bottom)) + 60px);
    width: calc(100vw - 24px - env(safe-area-inset-right) - env(safe-area-inset-left));
    height: min(620px, 100vh - 96px);
    height: min(620px, 100dvh - 96px - env(safe-area-inset-bottom));
  }
}
@media (prefers-reduced-motion: reduce) {
  .portal-chat-trigger {
    transition: none;
  }
  .portal-chat-panel, .portal-chat-header, .portal-chat-frame {
    animation: none;
  }
}`],
})
export class AppComponent implements OnInit, DoCheck, OnDestroy {
    constructor(@Inject( Service)         public service: Service,@Inject( ChangeDetectorRef)         public ref: ChangeDetectorRef,@Inject( Router    )         public router: Router    ) { }

    @ViewChild('chatTrigger') public chatTrigger: ElementRef<HTMLButtonElement>;
    @ViewChild('chatClose') public chatClose: ElementRef<HTMLButtonElement>;
    @ViewChild('chatFrame') public chatFrame: ElementRef<HTMLIFrameElement>;
    public chatOpen = false;
    public showChat = !/^\/login\/?$/.test(window.location.pathname);
    private chatNavigation: any;
    private readonly chatOrigin = 'https://chat.gsdc.seasonsoft.net';
    private chatFrameReady = false;
    private chatContextReady = false;
    private chatCommunity: string | null = null;
    private chatSessionKey = '';
    private chatRequestVersion = 0;
    private chatRequest: AbortController | null = null;

    private currentChatSessionKey(): string {
        const auth = this.service.auth;
        return JSON.stringify([auth?.status, auth?.session?.id, auth?.session?.community_id]);
    }

    public ngDoCheck() {
        if (this.chatOpen && this.chatSessionKey !== this.currentChatSessionKey()) {
            this.refreshChatContext();
        }
    }

    private async refreshChatContext() {
        this.chatSessionKey = this.currentChatSessionKey();
        const version = ++this.chatRequestVersion;
        this.chatRequest?.abort();
        const controller = new AbortController();
        this.chatRequest = controller;
        // Clear the preceding account's context while resolving a changed session.
        this.chatCommunity = null;
        this.sendChatContext();
        this.chatContextReady = false;
        const timeout = window.setTimeout(() => controller.abort(), 8000);
        let community: string | null = null;
        try {
            const response = await fetch('/chatbot/context', {
                method: 'POST', credentials: 'same-origin', cache: 'no-store',
                signal: controller.signal
            });
            const result = await response.json();
            if (response.ok && result.code === 200 && typeof result.data?.community === 'string') {
                community = result.data.community.trim() || null;
            }
        } catch {
            // A context lookup failure must not prevent use of the portal or chatbot.
        } finally {
            window.clearTimeout(timeout);
        }
        if (!this.chatOpen || version !== this.chatRequestVersion) return;
        this.chatRequest = null;
        this.chatCommunity = community;
        this.chatContextReady = true;
        this.sendChatContext();
    }

    public onChatFrameLoad() {
        this.chatFrameReady = true;
        this.sendChatContext();
    }

    @HostListener('window:message', ['$event'])
    public onChatMessage(event: MessageEvent) {
        if (!this.chatOpen || event.origin !== this.chatOrigin
            || event.source !== this.chatFrame?.nativeElement.contentWindow
            || event.data?.type !== 'GSDC_CHATBOT_READY' || event.data?.version !== 1) return;
        this.chatFrameReady = true;
        this.sendChatContext();
    }

    private sendChatContext() {
        if (!this.chatOpen || !this.chatFrameReady || !this.chatContextReady) return;
        this.chatFrame?.nativeElement.contentWindow?.postMessage({
            type: 'GSDC_PORTAL_CONTEXT', version: 1, community: this.chatCommunity
        }, this.chatOrigin);
    }

    public ngOnDestroy() {
        this.chatNavigation?.unsubscribe();
        this.chatRequestVersion++;
        this.chatRequest?.abort();
    }

    public async toggleChat() {
        if (!this.showChat) return;
        if (this.chatOpen) return this.closeChat();
        this.chatOpen = true;
        this.refreshChatContext();
        await this.service.render();
        this.chatClose?.nativeElement.focus();
    }

    public async closeChat() {
        this.chatOpen = false;
        this.chatFrameReady = false;
        this.chatContextReady = false;
        this.chatCommunity = null;
        this.chatRequestVersion++;
        this.chatRequest?.abort();
        this.chatRequest = null;
        await this.service.render();
        this.chatTrigger?.nativeElement.focus();
    }

    public onChatKeydown(event: KeyboardEvent) {
        if (event.key !== 'Escape' || !this.chatOpen) return;
        event.preventDefault();
        event.stopPropagation();
        this.closeChat();
    }

    public async ngOnInit() {
        await this.service.init(this);
        const updateChatVisibility = () => {
            const pathname = this.router.url.split(/[?#]/)[0];
            this.showChat = !/^\/login\/?$/.test(pathname);
            if (!this.showChat && this.chatOpen) this.closeChat();
        };
        updateChatVisibility();
        this.chatNavigation = this.router.events.subscribe(event => {
            if (event instanceof NavigationEnd) {
                updateChatVisibility();
                this.service.render();
            }
        });

        this.service.formatter = {
            date: (date, text) => {
                if (!text) text = "-";
                if (!date) return text;
                let res = moment(date).format("YYYY-MM-DD");
                if (res == 'Invalid date') return text;
                return res;
            },
            currency(number, isString = true) {
                if (!number) return "-";
                if (isString) {
                    let num = number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                    return num + "원";
                }

                const units = ['', '만', '억', '조', '경'];
                const parts = [];
                let remaining = number;

                for (let i = units.length - 1; i >= 0; i--) {
                    const unit = Math.pow(10000, i);
                    const part = Math.floor(remaining / unit);
                    remaining = remaining % unit;

                    if (part > 0) {
                        parts.push(part + units[i]);
                    }
                }

                if (remaining > 0) {
                    parts.push(remaining);
                }
                if (parts.length == 0) return '-';
                return parts.join(' ') + '원';
            }
        }
    }
}
